module.exports = __webpack_public_path__ + "img/maria-jose-garcia.c228a8c0.png";